import config from '@/config';
import useTranslations from '@/i18n/useTranslations';
import GenericPopup from '@/shared-components/popups/components/GenericPopup';

import ImageCropper from './ImageCropper';

import './styles/PopupUpdateArtlistCover.css';

const PopupUpdateArtlistCover = ({ 
  open, 
  image, 
  exitCrop, 
  setCroppedFile,
  setCroppedUrl,
  cropShape 
}) => {
  const t = useTranslations('common.profile.pages.artlist');
  const cropAreaClass = cropShape === 'circle' ? 'crop-circle' : 'crop-rect';

  const isBlobURL = typeof image?.image_id === "string" && 
    (image.image_id.startsWith("blob:") || image.image_id.startsWith("data:image/"));

  const imageUrl = isBlobURL
    ? image.image_id
    : `${config.app.imageServiceDomain}/${image?.image_id}/brightness=0.8`;

  return (
    <GenericPopup
      open={open}
      className={`artlist-cover-crop-popup ${cropAreaClass}`}
    >
      <div className="artlist-cover__header">
        <p className="artlist-cover__header-text">
          {t('cover_crop.title')}
        </p>
        <p className="artlist-cover__instructions">
          {t('cover_crop.instructions')}
        </p>
      </div>
      <ImageCropper
        key={imageUrl}
        source={imageUrl}
        width={window.innerWidth}
        height={window.innerHeight}
        cropShape="rect"
        aspect={1}
        continueLabel={t('cover_crop.actions.choose')}
        exitLabel={t('cover_crop.actions.exit')}
        exitCrop={exitCrop}
        setCroppedFile={setCroppedFile}
        setCroppedUrl={setCroppedUrl}
      />
    </GenericPopup>
  );
};

export default PopupUpdateArtlistCover;
